/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../../../context/Filtercontext";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import trans from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import {
	useGetActionQuery,
	useGetModulesQuery,
	useGetSubModulesQuery,
} from "../../../../Redux/service/Roles&Permissions/RolesPermissions";

export default function PermissionsHead({ setFilter, setCurrentPage, filter }) {
	//const [activeItem, setActiveItem] = useState("All vehicles");
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const { data: modulesData } = useGetModulesQuery();
	const { data: submodulesData } = useGetSubModulesQuery(
		{ module: filter.modules },
		{ skip: !filter.modules }
	);
	const { data: actionsData } = useGetActionQuery(
		{ resource: filter.resources },
		{ skip: !filter.resources }
	);
	console.log("Modules Data:", modulesData);
	console.log("Submodules Data:", submodulesData);
	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
				<InputSelect
					placeholder={trans("Modules")}
					options={modulesData?.data?.map((i) => ({
						label: trans(i.label),
						value: i.value,
					}))}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({
							...prev,
							modules: e,
							resources: null,
							actions: null,
						}));
						setCurrentPage(1);
					}}
				/>
				<InputSelect
					placeholder={trans("Resources")}
					options={submodulesData?.data?.map((i) => ({
						label: trans(i.label),
						value: i.value,
					}))}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, resources: e, actions: null }));
						setCurrentPage(1);
					}}
					value={filter.resources || null}
				/>
				<InputSelect
					placeholder={trans("Access Type")}
					options={actionsData?.data?.map((i) => ({
						label: trans(i.label),
						value: i.value,
					}))}
					value={filter.actions || null}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, actions: e }));
						setCurrentPage(1);
					}}
				/>
			</div>
		</>
	);
}
